// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KpisSettingsPopup_select_kpi__UO710 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.KpisSettingsPopup_text_field__9DUiF {
  width: 35%;
  height: 80px;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/KpiSettingsPopup/KpisSettingsPopup.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;AACd","sourcesContent":[".select_kpi {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.text_field {\n  width: 35%;\n  height: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select_kpi": `KpisSettingsPopup_select_kpi__UO710`,
	"text_field": `KpisSettingsPopup_text_field__9DUiF`
};
export default ___CSS_LOADER_EXPORT___;
